<template>
  <v-card>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-magnify</v-icon>
      <v-toolbar-title>Treaty Helplist</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn text icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <form data-vv-scope="queryTreatyNoFilterForm">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex lg6 xs12>
                        <v-text-field
                          data-vv-scope="queryTreatyNoFilterForm"
                          v-model="filtersTreatyNo.ttyNo"
                          :label="filtersTreatyNoLabel.ttyNo"
                          :error-messages="errors.collect('filterTreatyNo')"
                          data-vv-name="filterTreatyNo"
                          :data-vv-as="filtersTreatyNoLabel.ttyNo"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions right>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearTreatyNoFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text @click.prevent="doTreatyNoFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-card-text>
    <v-card-text style="max-height: 600px; overflow-y: auto">
      <v-data-table
        :headers="treatyNoHeaders"
        :items="treatyNoItems"
        v-bind:options.sync="paginationTreatyNo"
        :footer-props="{'items-per-page-options': itemsPerPage }"
        :server-items-length="totalItemsTreatyNo"
        :loading="loading"
        class="elevation-1"
        :no-data-text="noDataText"
      >
        <template v-slot:item="row"
          ><tr>
            <td>{{ row.item.ttyNo }}</td>
            <td>{{ row.item.ttyDesc }}</td>
            <td style="text-align: center">
              <v-btn text icon color="primary" type="submit" @click.prevent="assignTreatyNo(row.item)">
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </td>
          </tr></template
        >
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      actionName: '',
      showTreatyNoHelpList: false,
      filtersTreatyNoLabel: {
        ttyNo: 'Treaty No'
      },
      filtersTreatyNo: {
        ttyNo: undefined
      },
      treatyNoItems: [],
      totalItemsTreatyNo: 0,
      treatyNoHeaders: [
        { text: 'Treaty No', align: 'left', value: 'ttyNo' },
        { text: 'Description', value: 'ttyDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationTreatyNo: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  mounted() {
    this.doClearTreatyNoFilters()
  },
  methods: {
    closeDialog() {
      this.filtersTreatyNo.ttyNo = ''
      this.$emit('close')
    },
    doClearTreatyNoFilters() {
      this.filtersTreatyNo.ttyNo = ''
      this.fetchClaimTreatyNoData()
    },
    doTreatyNoFilters() {
      this.resetMessages()
      this.$validator.validateAll('queryTreatyNoFilterForm').then((result) => {
        if (result) {
          this.paginationTreatyNo.page = 1
          this.fetchClaimTreatyNoData()
        }
      })
    },
    assignTreatyNo(data) {
      // Use $emit to call parent Accounts page method assignFund and pass the value
      this.$emit('assign-treaty-info', data)
      this.$emit('close')
    }
  },
  computed: {},
  props: {
    riType: String
  },
  watch: {
    'paginationTreatyNo': function (value) {
      this.fetchClaimTreatyNoData()
    },
    riType: function (value) {
      this.fetchClaimTreatyNoData()
    }
  },
  mixins: [TableConst.default, commonAjaxMixin]
}
</script>
